import oneSipApiCall from "../apiCall.js"

const supplier={
  listSuppliers({commit,state},{router}){
    return oneSipApiCall(commit,state,router,'/list-all-supplier')
  },
}

export default supplier;